<p>
  <a
    routerLink="{{rlink}}"
    (click)="linkClicked()"
    [ngClass]="{ 'current-link' : selected, 'no-icon': !icon }"
    >
    @if (icon) {
      <i [class]="icon" aria-hidden="true"></i>
    }
    @if (svg) {
      <img class="svg-icon" [src]="'/assets/icons/' + svg + '.svg'" />
    }
    <span>
      <ng-content></ng-content>
    </span>
  </a>
</p>
